import Vue from 'vue'
import App from './App.vue'
import store from './store'
import Vuex from 'vuex'
import AtComponents from 'at-ui'
import YmapPlugin from 'vue-yandex-maps';

Vue.config.productionTip = false

window.hash = window.location.hash;

// ключ я-карт
window.api_key = '';

window.Vue = Vue;
Vue.use(Vuex)
Vue.use(AtComponents)

window.$ = window.jQuery = require('jquery');

window.axios = require('axios');
// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// window.axios.defaults.headers.common['Accept'] = 'application/json';
// window.axios.defaults.headers.common['Authorization'] = `Bearer ${(window.user)?window.user.api_token:''}`;


// Подключаем модуль яндекс карт
const settings = {
  apiKey: window.api_key,
  lang: 'ru_RU',
  coordorder: 'latlong',
  version: '2.1',
};

Vue.use(YmapPlugin, settings);

// регистрируем компоненты
Vue.component('y-map', require('./components/MapComponent.vue').default);

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
